import { Marker, Popup } from 'react-map-gl';
import { NavigationArrowIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { ShipPosition } from '../types/ShipPosition';
import { useAuth } from '@clerk/react';

interface ShipMarkerProps {
  ship: ShipPosition;
}

export default function ShipMarker({ ship }: ShipMarkerProps) {
  const [showPopup, setShowPopup] = useState(false);
  const { isSignedIn } = useAuth();

  const lat = Number(ship.LAT);
  const lon = Number(ship.LON);

  const rotation =
    ship.HEADING !== null
      ? (Number(ship.HEADING) - 310) % 360
      : null;

  return (
    <>
      <Marker longitude={lon} latitude={lat} anchor="center">
        <div
          onMouseEnter={() => setShowPopup(true)}
          onMouseLeave={() => setShowPopup(false)}
        >
          <NavigationArrowIcon
            className="h-5 w-5 text-blue-400 cursor-pointer hover:text-blue-300 transition-colors"
            color="#01FFFF"
            weight="duotone"
            style={{ transform: `rotate(${rotation}deg)` }}
          />
        </div>
      </Marker>

      {showPopup && (
        <Popup
          longitude={lon}
          latitude={lat}
          anchor="top"
          closeButton={false}
          closeOnClick={false}
          offset={30}
        >
          <div className="bg-black/90 backdrop-blur-md px-3 py-2 rounded-lg text-sm whitespace-nowrap text-white">
            <div className="font-semibold">{ship.SHIPNAME}</div>
            <div className="text-xs text-gray-300 mt-1">
              <div className="flex items-center justify-between gap-3">
                <strong>Speed:</strong>
                {isSignedIn ? <span className="text-green-400">{ship.SPEED} knots</span> : <span className="inline-block w-16 h-2.5 bg-gray-500/70 rounded blur-[2px]" />}
              </div>
              <div className="flex items-center justify-between gap-3">
                <strong>Fuel Burn:</strong>
                {isSignedIn ? <span className="text-green-400">{Number(ship.FUEL_CONSUMPTION).toFixed(2)} MT/hr</span> : <span className="inline-block w-16 h-2.5 bg-gray-500/70 rounded blur-[2px]" />}
              </div>
              <div className="flex items-center justify-between gap-3">
                <strong>Fuel Cost:</strong>
                {isSignedIn ? <span className="text-green-400">${Number(ship.HOURLY_FUEL_COST).toFixed(0)}/hr</span> : <span className="inline-block w-16 h-2.5 bg-gray-500/70 rounded blur-[2px]" />}
              </div>
              <div className="flex items-center justify-between gap-3">
                <strong>Annual Fuel Bill:</strong>
                {isSignedIn ? <span className="text-green-400">${Number(ship.ANNUAL_FUEL_BILL).toLocaleString()}</span> : <span className="inline-block w-16 h-2.5 bg-gray-500/70 rounded blur-[2px]" />}
              </div>
              <div className="flex items-center justify-between gap-3">
                <strong>Next Port:</strong>
                {isSignedIn ? <span className="text-green-400">{ship.NEXT_PORT_NAME}</span> : <span className="inline-block w-16 h-2.5 bg-gray-500/70 rounded blur-[2px]" />}
              </div>
              {!isSignedIn && (
                <div className="mt-1.5 text-[10px] text-blue-400 text-center">
                  🔒 Sign in to unlock — Captain
                </div>
              )}
            </div>
          </div>
        </Popup>
      )}
    </>
  );
}
